import _baseInput from './_baseInput.js';

export const baseInput = _baseInput;
